import { Reducer } from 'redux';
import { IAction } from '../types';
import { localKeyInfo } from '../config';
import LocalStore from '@/utils/store';

export interface LeftInfoState {
  showComId: string;
  reloadTime: number;
}

const LOCALKEY = localKeyInfo.leftInfo;
const localVoiceInfo = LocalStore.getValue<LeftInfoState>(LOCALKEY) || {};

export const leftInfo: LeftInfoState = {
  showComId: 'voiceHall',
  reloadTime: 0,
  ...localVoiceInfo
};

export const setLeftInfo: (payload: LeftInfoState) => IAction<LeftInfoState> = (payload: LeftInfoState) => ({
  type: 'setLeftInfo',
  payload
});

const voiceLeftReducer: Reducer<LeftInfoState, IAction<any>> = (state = leftInfo, action: IAction<any>) => {
  const { type, payload } = action;
  switch (type) {
    case 'setLeftInfo':
      LocalStore.setValue(LOCALKEY, payload);
      return {
        ...payload
      };
    default:
      return state;
  }
};

export default voiceLeftReducer;
